import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        requisites: '',
        items: [],
    },
    getters: {
        requisites(state){
            return state.requisites;
        },
        contacts(state){
            return state.items;
        }
    },
    mutations: {
        loadContacts(state, data){
            state.requisites = data.requisites;
            state.items = data.items;

            for(let i = 0; i < state.items.length; i++){
                let req = getXmlHttp();
                req.onreadystatechange = () => {
                    if (req.readyState === 4) {
                        if(req.status === 200) {
                            let _json = JSON.parse(req.responseText);
                            if(_json.response.GeoObjectCollection.featureMember.length){
                                this.dispatch('contacts/updateCoordinates', {coordinates: _json.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' '), index: i});
                            }
                        }
                    }
                };

                req.open('GET', 'https://geocode-maps.yandex.ru/1.x/?format=json&geocode=' + state.items[i].address, true);
                req.send();
            }
        },
        updateCoordinates(state, data){
            state.items[data.index].coordinates = [data.coordinates[1], data.coordinates[0]];
        }
    },
    actions: {
        LoadContacts ({commit}){
            if(!this.state.contacts.items.length) {
                return new Promise((resolve, reject) => {
                    Vue.http.get('contacts.json')
                        .then(response => response.json())
                        .then(data => {
                            commit('loadContacts', data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        updateCoordinates(store, data){
            store.commit('updateCoordinates', data)
        }
    }
};

function getXmlHttp(){
    let xmlhttp;
    try {
        xmlhttp = new ActiveXObject("Msxml2.XMLHTTP");
    } catch (e) {
        try {
            xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
        } catch (E) {
            xmlhttp = false;
        }
    }
    if (!xmlhttp && typeof XMLHttpRequest !== 'undefined')
        xmlhttp = new XMLHttpRequest();
    return xmlhttp;
}


// WEBPACK FOOTER //
// ./src/store/modules/contacts.js